<div class="app-mam-follower fx-panel">
  <div class="fx-panel-body">
    <div class="p-15">
      <div class="row mb-15">
        <div class="col-md-6 col-xs-12">
          <div
            class="input-group search-group">
            <input
              type="text"
              class="form-control color-black"
              name="keyword"
              [(ngModel)]="condition.keyword"
              (keyup)="search($event)"
              placeholder="Search"/>
            <div class="input-group-append">
              <button
                class="btn btn-main"
                type="button"
                (click)="search('click')"
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <div class="table-responsive">
            <table class="rox-table table-bordered">
              <thead>
              <tr>
                <th class="text-center">No</th>
                <th class="text-center">User Name</th>
                <th class="text-center">Email</th>
                <th class="text-center">MT5 Account</th>
                <th class="text-center">MT5 Group</th>
                <th class="text-center" *ngIf="permission.allowCreating"></th>
              </tr>
              </thead>
              <tbody>
              <tr
                *ngFor="
                          let item of data
                            | paginate
                              : {
                                  id: 'mamFollower',
                                  itemsPerPage: pageInfo.pageSize,
                                  currentPage: pageInfo.pageIndex,
                                  totalItems: pageInfo.totalRecord
                                };
                          let i = index
                        ">
                <td class="text-center">{{item.id}}</td>
                <td class="text-center">{{item.getUserName()}}</td>
                <td class="text-center">{{item.email}}</td>
                <td class="text-center">{{item.login}}</td>
                <td class="text-center">
                  <span labelGroup="{{item.currentGroup}}"></span>
                </td>
                <td class="text-center" create-permission>
                  <a
                    href="javascript:void(0)"
                    class="text-blue-lighter"
                    (click)="getMamFollowerInfo(item)"
                    data-bs-toggle="modal"
                    data-bs-target="#modalMamFollower"
                  >View</a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-15">
        <div class="col">
          <div class="pagination-wrapper">
            <pagination-controls
              id="mamFollower"
              (pageChange)="pageChanged($event)"
              autoHide="true"
              responsive="true"
              previousLabel="Prev"
              nextLabel="Next"
            >
            </pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade fx-modal" id="modalMamFollower">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content" *ngIf="dataSelected">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">
            {{dataSelected.email}}
            ({{dataSelected.getUserName()}})
          </h4>
          <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body mb-3">
          <div class="row">
            <div class="col">
              <div class="table-responsive">
                <table class="fx-table table-bordered">
                  <thead>
                  <tr>
                    <th class="text-center">Follower MT5 Account</th>
                    <th class="text-center">Follower Group</th>
                    <th class="text-center"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td class="text-center">{{dataSelected.login}}</td>
                    <td class="text-center">
                      <select style="color: #333 !important;" [(ngModel)]="conditionUpdate.group" class="form-control">
                        <option value="">Select group</option>
                        <option *ngFor="let group of dataSelected.groups" [value]="group">
                          <span labelGroup="{{group}}"></span>
                        </option>
                      </select>
                    </td>
                    <td class="text-center">
                      <div class="btn-group">
                        <button class="btn btn-red" (click)="processCloseAll()">
                          Close all positions
                        </button>
                        <button class="btn btn-green" (click)="processApply()">
                          Apply
                        </button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
